import { IBarrier } from '../types'

export type PresenterProps = {
    onChanged: () => void
    barrierPointers: IBarrier[]
    editable: boolean
}

type IMethod = 'QUANTITATIVE' | 'HYBRID' | 'QUALITATIVE' | string
export type IUpdateModeFrontPresenter = {
    updateModeCode: string
    method: IMethod
    label: string
    component: React.FC<PresenterProps>
    validationFunction: (barrier: IBarrier) => string[]
}
type IReposityMap = Map<string, IUpdateModeFrontPresenter>

type IKeyValuesObject = {
    label: string
    value: string
}

export class UpdateModeFrontAPI {
    private repository: IReposityMap = new Map()

    addUpdateModeFrontPresenter(updateModePresenter: IUpdateModeFrontPresenter): void {
        this.repository.set(updateModePresenter.updateModeCode, updateModePresenter)
    }

    removeUpdateModeFrontPresenter(updateModeCode: string): void {
        if (updateModeCode) {
            this.repository.delete(updateModeCode)
        }
    }

    getUpdateModeFrontPresenter(updateModeCode: string): IUpdateModeFrontPresenter {
        if (updateModeCode) {
            return this.repository.get(updateModeCode)
        }

        return null
    }

    getRepositoryKeysWithTitles(): IKeyValuesObject[] {
        const dataToSend: IKeyValuesObject[] = []
        this.repository.forEach((value, key) => {
            dataToSend.push({ label: value.label, value: key })
        })

        return dataToSend
    }

    getRepositoryKeysWithTitlesByMethod(method: IMethod): IKeyValuesObject[] {
        const dataToSend: IKeyValuesObject[] = []
        this.repository.forEach((value, key) => {
            if (value.method === method) {
                dataToSend.push({ label: value.label, value: key })
            }
        })

        return dataToSend
    }

    getUpdateModeLabel(updateModeCode: string): string {
        return this.repository.get(updateModeCode)?.label
    }

    getUpdateModeMethod(updateModeCode: string): string {
        return this.repository.get(updateModeCode)?.method
    }

    getValidationForUpdateMode(updateModeCode: string, barrier: IBarrier): string[] {
        const updateModeComponent = this.repository.get(updateModeCode)
        if (!updateModeComponent) {
            return ['engine does not exist']
        }
        let arrayOfErrors = updateModeComponent.validationFunction(barrier)
        if (arrayOfErrors === null || arrayOfErrors === undefined) {
            arrayOfErrors = []
        }

        return arrayOfErrors
    }
}

export const updateModeFrontAPI = new UpdateModeFrontAPI()
